export default "__VITE_PUBLIC_ASSET__2974901d__"